"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFocusRingEnabled = void 0;
exports.isFocusRingEnabled = function () {
    return typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('#SITE_CONTAINER .visual-focus-on.keyboard-tabbing-on'))
        ? true
        : false;
};
//# sourceMappingURL=focusRing.js.map